export default __webpack_public_path__ + "static/media/single-project-page-05-img-14.1a5dc3b1.jpg";